@if (trialLogs$ | async; as trialLogs) {
  <div class="table-container">
    <table mat-table [dataSource]="trialLogs">
      <ng-container matColumnDef="logType">
        <th mat-header-cell *matHeaderCellDef> Log Type </th>
        <td mat-cell *matCellDef="let log">
          <span class="log-type" [class]="getLogTypeClass(log.LogType)">{{log.LogType}} </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="updatedOn">
        <th mat-header-cell *matHeaderCellDef> Updated On </th>
        <td mat-cell *matCellDef="let log"> {{log.UpdatedOn}} </td>
      </ng-container>
      <ng-container matColumnDef="updatedBy">
        <th mat-header-cell *matHeaderCellDef> Updated By </th>
        <td mat-cell *matCellDef="let log"> {{log.UpdatedBy}} </td>
      </ng-container>
      <ng-container matColumnDef="notes">
        <th mat-header-cell *matHeaderCellDef> Notes </th>
        <td mat-cell *matCellDef="let log"> {{log.Notes}} </td>
      </ng-container>
      <ng-container matColumnDef="changes">
        <th mat-header-cell *matHeaderCellDef> Changes </th>
        <td mat-cell *matCellDef="let log">
          @for (change of log.Changes; track change) {
            <div> {{ change.PropertyName }}: {{ change.PreviousValue }}
            &#8594; {{ change.CurrentValue }}</div>
          }
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          <div class="no-data-row">
            <mat-icon>format_list_bulleted</mat-icon>
            No logs yet
          </div>
        </td>
      </tr>
    </table>
  </div>
}